export const API_BASE_DEV = "http://0.0.0.0:22003/v1";
export const API_BASE_PROD = "https://smart-recruit.itconnexion.net/api/v1";
